"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getString = void 0;

var _strings = require("../../../../config/strings");

var STRINGS = {
  GWG_FILL_ALL_FIELDS: {
    de: 'Bitte füllen Sie alle Felder aus'
  },
  GWG_SEND_MAIL_ERROR: {
    de: 'Es gab einen Fehler beim Versenden des Zertifikats, bitte versuche Sie es erneut.'
  },
  SEND_BCC_COPY_TO: {
    de: 'Eine Kopie des Zertifikats an $0 senden.'
  },
  SEND_DATA: {
    de: 'Daten absenden'
  },
  GWG_CERTIFICATE_SENT: {
    de: '<b>Ihre Teilnahmebescheinigung wurde versendet.</b><br /><br />Vielen Dank für die Teilnahme am Online-Lernprogramm zum Geldwäschegesetz.'
  }
};

function addStringsToGlobalList() {
  if (!_strings.addStrings) {
    console.log('addStrings is still null');
    setTimeout(addStringsToGlobalList, 50);
    return;
  } // console.log('addstrings is possible now')


  (0, _strings.addStrings)(STRINGS);
}

addStringsToGlobalList(); // named export for better import proposals by webstorm

var getString = function getString() {
  return _strings.getString.apply(void 0, arguments);
};

exports.getString = getString;